var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvailableBeds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.7778V9.88889C1 9.29952 1.23413 8.73429 1.65087 8.31754C2.06762 7.90079 2.63285 7.66667 3.22222 7.66667M3.22222 7.66667H18.7778M3.22222 7.66667V3.22222C3.22222 2.63285 3.45635 2.06762 3.8731 1.65087C4.28984 1.23413 4.85507 1 5.44444 1H16.5556C17.1449 1 17.7102 1.23413 18.1269 1.65087C18.5437 2.06762 18.7778 2.63285 18.7778 3.22222V7.66667M18.7778 7.66667C19.3671 7.66667 19.9324 7.90079 20.3491 8.31754C20.7659 8.73429 21 9.29952 21 9.88889V18.7778M1 16.5556H21",
    stroke: "#5981E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableBeds);
export default __webpack_public_path__ + "static/media/available_beds.4b87c0b145688c9afd3b07bbc315f9ac.svg";
export { ForwardRef as ReactComponent };